import * as Consts from './Consts';
import { TaskStatus, TaskExamStatus } from './Consts';
import {ContractMuncaStatus, CourseRegistrationStatus, AuthzStatus} from './Consts';
import { RoleClient, RoleSystem, RoleSubcontractor, AuthzIscirAFCode } from './Consts';
import { ClientType, ServiceType } from './Consts';
import { EeAuthzType } from './Consts';

export const judeteArray = [
    { id: 'Alba', name: 'Alba' },
    { id: 'Arad', name: 'Arad' },
    { id: 'Arges', name: 'Arges' },
    { id: 'Bacau', name: 'Bacau' },
    { id: 'Bihor', name: 'Bihor' },
    { id: 'Bistrita-Nasaud', name: 'Bistrita-Nasaud' },
    { id: 'Botosani', name: 'Botosani' },
    { id: 'Braila', name: 'Braila' },
    { id: 'Brasov', name: 'Brasov' },
    { id: 'Bucuresti', name: 'Bucuresti' },
    { id: 'Buzau', name: 'Buzau' },
    { id: 'Calarasi', name: 'Calarasi' },
    { id: 'Caras-Severin', name: 'Caras-Severin' },
    { id: 'Cluj', name: 'Cluj' },
    { id: 'Constanta', name: 'Constanta' },
    { id: 'Covasna', name: 'Covasna' },
    { id: 'Dimbovita', name: 'Dimbovita' },
    { id: 'Dolj', name: 'Dolj' },
    { id: 'Galati', name: 'Galati' },
    { id: 'Gorj', name: 'Gorj' },
    { id: 'Giurgiu', name: 'Giurgiu' },
    { id: 'Harghita', name: 'Harghita' },
    { id: 'Hunedoara', name: 'Hunedoara' },
    { id: 'Ialomita', name: 'Ialomita' },
    { id: 'Iasi', name: 'Iasi' },
    { id: 'Ilfov', name: 'Ilfov' },
    { id: 'Maramures', name: 'Maramures' },
    { id: 'Mehedinti', name: 'Mehedinti' },
    { id: 'Mures', name: 'Mures' },
    { id: 'Neamt', name: 'Neamt' },
    { id: 'Olt', name: 'Olt' },
    { id: 'Prahova', name: 'Prahova' },
    { id: 'Salaj', name: 'Salaj' },
    { id: 'Satu Mare', name: 'Satu Mare' },
    { id: 'Sibiu', name: 'Sibiu' },
    { id: 'Suceava', name: 'Suceava' },
    { id: 'Teleorman', name: 'Teleorman' },
    { id: 'Timis', name: 'Timis' },
    { id: 'Tulcea', name: 'Tulcea' },
    { id: 'Vaslui', name: 'Vaslui' },
    { id: 'Vilcea', name: 'Vilcea' },
    { id: 'Vrancea', name: 'Vrancea' }
];

export const employerTypeArray = [
    { id: 'Agentie', name: 'Agentie' },
    { id: 'Filiala', name: 'Filiala' },
    { id: 'Punct_Lucru', name: 'Punct de Lucru' },
    { id: 'Reprezentanta', name: 'Reprezentanta' },
    { id: 'Subunitate', name: 'Subunitate' },
    { id: 'Sucursala', name: 'Sucursala' },
    { id: 'Unitate_Principala', name: 'Unitate Principala' },
    { id: 'Alte_Tipuri', name: 'Alte Tipuri' }
];

export const formaJuridicaArray = [
    { id: 'SA', name: 'Societate pe Acţiuni' },
    { id: 'SRL', name: 'Societate cu Răspundere Limitată' },
    { id: 'SCS', name: 'Societate in Comandita Simpla' },
    { id: 'SNC', name: 'Societate în Nume Colectiv' },
    { id: 'RA', name: 'Regie Autonomă' },
    { id: 'OC1', name: 'Cooperativă meşteşugărească' },
    { id: 'OC2', name: 'Cooperativă de consum' },
    { id: 'OC3', name: 'Cooperativă de credit' },
    { id: 'SAG', name: 'Societate agricolă' },
    { id: 'OSL', name: 'Organizaţie cu Scop Lucrativ' },
    { id: 'SCA', name: 'Societate în Comandită pe Acţiuni' },
    { id: 'ALT', name: 'Alta Forma Juridica' }
];

export const propertyTypeArray = [
    { id: 'CS_Integral_Stat', name: 'Capital social integral de stat' },
    { id: 'CS_Stat_Peste_50', name: 'Capital social de stat peste 50%' },
    { id: 'CS_Privat_Peste_50', name: 'Capital social privat peste 50%' },
    { id: 'CS_Rom_sau_Rom_Strain', name: 'Capital social integral privat românesc sau românesc şi străin' },
    { id: 'Cooperatista', name: 'Proprietate cooperatistă' },
    { id: 'Obsteasca', name: 'Proprietate obştească' },
    { id: 'Integral_Straina', name: 'Proprietate integral străină' },
    { id: 'Publica_Interes_National_Local', name: 'Proprietate publică de interes naţional şi local' },
    { id: 'Alte_Tipuri', name: 'Alte tipuri de capital' }
];

export const employerSizeArray = [
    { id: '0', name: '0 angajaţi' },
    { id: '1_9', name: '1-9 angajaţi' },
    { id: '1_49', name: '10-49 angajaţi' },
    { id: '50_249', name: '50-249 angajaţi' },
    { id: '250_499', name: '250-499 angajaţi' },
    { id: '500_Or_More', name: '500 Angajaţi sau mai mult' },
    { id: 'Unknown', name: 'Nr. Necunoscut de angajaţi' }
];

export const sexType = [
    {id: 'M', name: 'M'},
    {id: 'F', name: 'F'}
];

export const stareCivila = [
    {id: 'Casatorit_a', name: 'Casatorit(a)'},
    {id: 'Necasatorit_a', name: 'Necasatorit(a)'},
    {id: 'Divortat_a', name: 'Divortat(a)'},
    {id: 'Vaduv_a', name: 'Vaduv(a)'}
];

export const persoaneIntretinere = [
    {id: 'NA', name: 'Nimeni'},
    {id: 'Copii', name: 'Copii'},
    {id: 'Altele', name: 'Altele'}
];

export const cetatenie = [
    {id: 'Romana', name: 'Romana'},
    {id: 'Cetatenie_UE', name: 'Alte cetatenii din UE'},
    {id: 'Cetatenie_afara_UE', name: 'Centenii din afara UE'},
    {id: 'Necunoscuta', name: 'Necunoscuta'}
];

export const statutProfesional = [
    {id: '000', name: '000 - Forma de incadrare în munca necunoscuta'},
    {id: '100', name: '100 - Lucrător pe cont propriu'},
    {id: '300', name: '300 - Lucrător în regim de lucru (permanent/temporar) şi cu program de lucru (complet/timp parţial) - nespecificate'},
    {id: '301', name: '301 - Lucrător în regim de lucru nespecificat, dar cu program de lucru complet'},
    {id: '302', name: '302 - Lucrător în regim de lucru nespecificat, dar cu program de lucru parţial'},
    {id: '310', name: '310 - Lucrător în regim de lucru permanent şi cu program de lucru - nespecificat'},
    {id: '311', name: '311 - Lucrător în regim de lucru permanent şi cu program de lucru - complet'},
    {id: '312', name: '312 - Lucrător în regim de lucru permanent şi cu program de lucru - parţial'},
    {id: '320', name: '320 - Lucrător în regim de lucru temporar, dar cu program de lucru - nespecificat'}, 
    {id: '321', name: '321 - Lucrător în regim de lucru temporar şi cu program de lucru - complet'},
    {id: '322', name: '322 - Lucrător în regim de lucru temporar şi cu program de lucru - parţial'},
    {id: '400', name: '400 - Lucrător familial neremunerat'},
    {id: '500', name: '500 - Ucenic'},
    {id: '900', name: '900 - Alt statut profesional'},
];

export const durataMuncii = [
    {id: 'Intreaga_8h', name: 'Norma intreaga 8h'},
    {id: 'Intreaga_Minori_6h', name: 'Norma intreaga minori 6h'},
    {id: 'Partiala_1h', name: 'Norma partiala 1h'},
    {id: 'Partiala_2h', name: 'Norma partiala 2h'},
    {id: 'Partiala_3h', name: 'Norma partiala 3h'},
    {id: 'Partiala_4h', name: 'Norma partiala 4h'},
    {id: 'Partiala_5h', name: 'Norma partiala 5h'},
    {id: 'Partiala_6h', name: 'Norma partiala 6h'},
    {id: 'Partiala_7h', name: 'Norma partiala 7h'}
];


export const angajatAutorizatIscir = [
    {id: 'aa_0', name: 'Fochist cazane de abur şi apă fierbinte'},
    {id: 'aa_1', name: 'Fochist cazane mici de abur'},
    {id: 'aa_2', name: 'Fochist cazane de apă caldă şi cazane de abur de joasă presiune'},
    {id: 'aa_3', name: 'Fochist cazane conduse de calculator'},
    {id: 'aa_4', name: 'Laborant operator centrale termice'},
    {id: 'aa_5', name: 'Automatist pentru supraveghere şi întreţinere cazane'},
    {id: 'aa_6', name: 'Operator umplere recipiente GPL'},
    {id: 'aa_7', name: 'Îmbuteliator fluide sub presiune'},
    {id: 'aa_8', name: 'Macaragiu'},
    {id: 'aa_9', name: 'Maşinist pod rulant'},
    {id: 'aa_10', name: 'Stivuitorist'},
    {id: 'aa_11', name: 'Liftier'},
    {id: 'aa_12', name: 'Mecanic trolist'},
    {id: 'aa_13', name: 'Operator la platforme pentru lucrul la înălţime'},
    {id: 'aa_14', name: 'Sudor'},
    {id: 'aa_15', name: 'Sudor electric'}, 
    {id: 'aa_16', name: 'Sudor oxi-gaz'}, 
    {id: 'aa_17', name: 'Operator sudare ţevi şi fitinguri din polietilenă de înaltă densitate PEHD'},
    {id: 'aa_18', name: 'Operator control nedistructiv cu radiaţii penetrante'},
    {id: 'aa_19', name: 'Operator control nedistructiv cu ultrasunete'}, 
    {id: 'aa_20', name: 'Operator control nedistructiv cu lichide penetrante'}, 
    {id: 'aa_21', name: 'Operator control nedistructiv cu particule magnetice'},
    {id: 'aa_22', name: 'Operator control nedistructiv prin curenţi turbionari'},
    {id: 'aa_23', name: 'Operator control nedistructiv pentru verificarea etanşeităţii'},
    {id: 'aa_24', name: 'Operator control nedistructiv pentru examinarea magneto-inductivă'},
    {id: 'aa_25', name: 'Operator control nedistructiv pentru examinare vizuală'},
    {id: 'aa_26', name: 'Operator control nedistructiv pentru emisie acustică'},
    {id: AuthzIscirAFCode.OperatorRSVTI, name: 'Operator responsabil cu supravegherea tehnică a instalaţiilor (RSVTI)'},
];


export const angajatAutorizatIscirShort = [
    {id: 'aa_0', name: 'Fochist cazane de abur şi apă fierbinte, cazane de apă caldă şi cazane de abur de joasă presiune şi cazane conduse de calculator'},
    {id: 'aa_4', name: 'Laborant operator centrale termice'},
    {id: 'aa_5', name: 'Automatist pentru supraveghere şi întreţinere cazane'},
    {id: 'aa_6', name: 'Operator umplere recipiente GPL'},
    {id: 'aa_7', name: 'Imbuteliator fluide sub presiune'},
    {id: 'aa_8', name: 'Macaragiu'},
    {id: 'aa_9', name: 'Maşinist pod rulant'},
    {id: 'aa_10', name: 'Stivuitorist'},
    {id: 'aa_11', name: 'Liftier'},
    {id: 'aa_12', name: 'Mecanic trolist'},
    {id: AuthzIscirAFCode.OperatorRSVTI, name: 'Operator responsabil cu supravegherea tehnică a instalaţiilor (RSVTI)'},
];

export const angajatAutorizatIntern = [
    {id: 'AAI_1', name: 'Legător de sarcină pentru macarale'},
    {id: 'AAI_2', name: 'Manevrant pentru macarale cu acţionare manuală'},
    {id: 'AAI_3', name: 'Manevrant pentru stivuitoare cu acţionare manuală'},
    {id: 'AAI_4', name: 'Manevrant pentru mecanisme de ridicat'},
    {id: 'AAI_5', name: 'Manevrant pentru platforme ridicătoare deplasabile/nedeplasabile'},
    {id: 'AAI_6', name: 'Manevrant pentru elevatoare pentru vehicule'},
    {id: 'AAI_7', name: 'Manevrant pentru ascensoare cu schip'},
    {id: 'AAI_8', name: 'Manevrant pentru ascensoare de materiale, cu comandă de la punct fix din şantierele de construcţii'},
    {id: 'AAI_9', name: 'Manevrant pentru ascensoare de construcţie specială pentru materiale'},
    {id: 'AAI_10', name: 'Manevrant pentru trape/instalaţii de cortină pentru incendiu'},
    {id: 'AAI_11', name: 'Manevrant pentru echipamente din parcurile de distracţii'},
];

// IPAD= instalații personal auxiliar deservire
export const instalatiiPersonalAuxiliar = [
    {id: 'IPAD_1', name: 'Macarale'},
    {id: 'IPAD_2', name: 'Macarale cu actionare manuala'},
    {id: 'IPAD_3', name: 'Stivuitoare cu actionare manuala'},
    {id: 'IPAD_4', name: 'Vinciuri'},
    {id: 'IPAD_5', name: 'Trolii'},
    {id: 'IPAD_6', name: 'Palane'},
    {id: 'IPAD_7', name: 'Dispozitive de ridicat si tractiune'},
    {id: 'IPAD_8', name: 'Transpalete manuale'},
    {id: 'IPAD_9', name: 'Transpalete electrice fara catarg'},
    {id: 'IPAD_10', name: 'Platforma autoridicatoare/Nacela'},
    {id: 'IPAD_11', name: 'Elevatoare auto'},
    {id: 'IPAD_12', name: 'Ascensoare cu schip'},
    {id: 'IPAD_13', name: 'Ascensoare de materiale, comanda punct fix'},
    {id: 'IPAD_14', name: 'Ascensoare de constructie speciala pentru materiale'},
    {id: 'IPAD_15', name: 'Trape/Instalatii de cortina pentru incendiu'},
    {id: 'IPAD_16', name: 'Echipamente agreement'},
];

export const angajatAutorizatTypes = [
    {id: EeAuthzType.Iscir, name: 'Autorizat ISCIR'},
    {id: EeAuthzType.Internal, name: 'Autorizat Intern'}
];

export const clientTypeOptions = [
    {id: ClientType.ServicuExtern, name: 'Serviciu Extern'},
    {id: ClientType.Angajator, name: 'Angajator'}
];

export const clientServiceTypeOptions = [
    {id: ServiceType.Internal, name: 'Intern'},
    {id: ServiceType.External, name: 'Extern'}
];

export const roleSystem = [
    {id: RoleSystem.Admin, name: 'Administrator System'},
    {id: RoleSystem.User, name: 'Utilizator System'},
];

export const roleClient = [
    {id: RoleClient.Admin, name: 'Administrator Client'},
    {id: RoleClient.User, name: 'Utilizator Client'},
    {id: RoleClient.UserSpecificEmployer, name: 'Utilizator Client [Angajator Specific]'},
];

export const roleSubcontractor = [
    {id: RoleSubcontractor.UserSubcon, name: 'Subcontractor'},
];

export const examResultStatus = [
    {value: TaskExamStatus.Accepted, label: 'Admis' },
    {value: TaskExamStatus.Rejected, label: 'Respins' },
    {value: TaskExamStatus.Absent, label: 'Absent' }
];

export const taskStatus = [
    {id: TaskStatus.InProgress, name: 'In Lucru'},
    {id: TaskStatus.Completed, name: 'Finalizat'},
    {id: TaskStatus.Cancelled, name: 'Anulat'},
];

export const employeeContractStatus = [
    {id: ContractMuncaStatus.Activ, name: 'CIM - activ'},
    {id: ContractMuncaStatus.Inchis, name: 'CIM - inchis'},
    {id: ContractMuncaStatus.Suspendat, name: 'CIM - suspendat'},
    {id: ContractMuncaStatus.ConcediuMedical, name: 'CMB - Certificat concediu medical boala'},
    {id: ContractMuncaStatus.ConcediuIngrijireCopil, name: 'CIC - Concediu ingrijire copil'},
];

export const authorizationStatusOptions = [
    {id: AuthzStatus.Active, name: 'Activ'},
    {id: AuthzStatus.Suspended, name: 'Suspendat'},
    {id: AuthzStatus.NotUsed, name: 'Nefolosit'}
];

export const courseRegistrationOptions = [
    {id: CourseRegistrationStatus.Registered, name: 'Inscris'},
    {id: CourseRegistrationStatus.CertificateIssued, name: 'Emitere Adeverinta'},
    {id: CourseRegistrationStatus.Completed, name: 'Curs Finalizat (Talon Emis)'},
];
